// extracted by css-extract-rspack-plugin
export default {"wrapper":"_c0a6a70f _5afcc48f","spinnerContainer":"_b3361726"};